import React from "react";
import ReactQuill from "react-quill";
import { useController } from "react-hook-form";
import "react-quill/dist/quill.snow.css"; // Import the styles

const TextEditor = ({
  label,
  name,
  control,
  required = false,
  defaultValue = "",
  labelClass = "font-bold text-base",
  height = "140px", // Added height prop with default value
  readOnly = false,
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { required: required ? `${label} is required` : false },
    defaultValue: defaultValue,
  });

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  // Custom styles for the Quill editor
  const quillStyle = {
    height: height,
    maxHeight: "80vh",
  };

  return (
    <div className="w-full flex flex-col gap-2">
      <label className={`${labelClass}`} htmlFor={name}>
        {label}
        {required && <span className="text-red-500 text-xs ml-0.5">*</span>}
      </label>
      <div className="rounded-lg overflow-hidden border focus-within:border-blue-300 focus-within:ring-2 focus-within:ring-blue-100">
        <ReactQuill
          theme="snow"
          value={value || ""}
          readOnly={readOnly}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder="Write something amazing..."
          className="bg-white"
          style={quillStyle}
        />
      </div>
      {error && <span className="text-red-500 text-sm">{error.message}</span>}
    </div>
  );
};

export default TextEditor;
